import { IdoSharedQueriesForTheKanbanBoard } from 'src/models/idoList';

import { Callback } from 'src/util/query/models/Callback';

import { IdoListCallbackStoreContract } from '../interfaces';

type RequiredKanbanFields =
	| 'idoInstanceId'
	| 'label'
	| 'serializedIdoIdoListToolbarHiddenDetailsSearchString'
	| 'value';

type ValidKanbanSharedQuery = {
	[K in RequiredKanbanFields]: string;
} & IdoSharedQueriesForTheKanbanBoard;

const isValidKanbanSharedQuery = (entry: IdoSharedQueriesForTheKanbanBoard): entry is ValidKanbanSharedQuery =>
	entry.idoInstanceId !== null &&
	entry.label !== null &&
	entry.serializedIdoIdoListToolbarHiddenDetailsSearchString !== null &&
	entry.value !== null;

export class GetTheSharedQueriesForTheKanbanBoardCallBack extends Callback<IdoSharedQueriesForTheKanbanBoard[]> {
	public constructor(private readonly store: IdoListCallbackStoreContract) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
	};

	successCallbackFunction = (successResponse: IdoSharedQueriesForTheKanbanBoard[] | null): void => {
		if (!Array.isArray(successResponse)) {
			this.store.setSharedQueriesForTheKanbanBoard([]);
			return;
		}

		this.store.setSharedQueriesForTheKanbanBoard(successResponse.filter(isValidKanbanSharedQuery));
	};
}
